import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DEFAULT_TRACING_COOKIE_NAME } from '../../global-constants';
import { getCookie } from '../../gql/client';
import { logger } from '../../logger/logger';
import { getLocalhostHeadersAsync } from '../../utils/localhostHeaders';
var getNextHeaders = function () {
  var _ref = _asyncToGenerator(function* () {
    if (typeof window !== 'undefined') return null;
    try {
      var _yield$import = yield import('next/headers'),
        headers = _yield$import.headers;
      return headers;
    } catch (_unused) {
      return null;
    }
  });
  return function getNextHeaders() {
    return _ref.apply(this, arguments);
  };
}();
var getNextCookies = function () {
  var _ref2 = _asyncToGenerator(function* () {
    if (typeof window !== 'undefined') return null;
    try {
      var _yield$import2 = yield import('next/headers'),
        cookies = _yield$import2.cookies;
      return cookies;
    } catch (_unused2) {
      return null;
    }
  });
  return function getNextCookies() {
    return _ref2.apply(this, arguments);
  };
}();
var deriveOperationName = (query, providedName) => {
  var _match$;
  if (providedName) {
    return providedName;
  }
  var match = query.match(/\b(query|mutation)\s+([A-Za-z0-9_]+)/);
  return (_match$ = match === null || match === void 0 ? void 0 : match[2]) !== null && _match$ !== void 0 ? _match$ : 'anonymous';
};
var buildLogContext = (operationName, variables, logContext) => ({
  operationName,
  variables,
  pageName: logContext === null || logContext === void 0 ? void 0 : logContext.pageName,
  userId: logContext === null || logContext === void 0 ? void 0 : logContext.userId,
  companyId: logContext === null || logContext === void 0 ? void 0 : logContext.companyId
});
export var executeGraphQLQuery = function () {
  var _ref3 = _asyncToGenerator(function* (query, variables, selector, token) {
    var _process$env$NEXT_APP, _process;
    var revalidateCache = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var returnErrors = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    var headers = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
    var logContext = arguments.length > 7 ? arguments[7] : undefined;
    var contentRequest = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
    var canLog = isServerSide();
    var operationName = deriveOperationName(query, logContext === null || logContext === void 0 ? void 0 : logContext.operationName);
    var startTime = performance.now();
    var success = false;
    var expirationTime = (_process$env$NEXT_APP = (_process = process) === null || _process === void 0 || (_process = _process.env) === null || _process === void 0 ? void 0 : _process.NEXT_APP_STATIC_CONTENT_CACHE_TTL) !== null && _process$env$NEXT_APP !== void 0 ? _process$env$NEXT_APP : 0;
    var cacheOptions = revalidateCache ? {
      cache: 'no-cache'
    } : {
      next: {
        revalidate: Number(expirationTime)
      }
    };
    try {
      var _data, _data2, _data3, _data4, _data5;
      var headersObj = yield getHeaders(token, headers, contentRequest);
      var isAppRouterEnv = yield isAppRouter();
      var fetchResponse;
      var data;
      if (isServerSide() && isAppRouterEnv) {
        var _yield$import3 = yield import('./cachedFetch'),
          cachedFetch = _yield$import3.cachedFetch;
        fetchResponse = yield cachedFetch(getEndpoint(), JSON.stringify(headersObj), JSON.stringify({
          query,
          variables
        }), JSON.stringify(cacheOptions));
        if (!fetchResponse) {
          return null;
        }
        data = fetchResponse;
      } else {
        fetchResponse = yield fetch(getEndpoint(), _objectSpread({
          method: 'POST',
          headers: headersObj,
          body: JSON.stringify({
            query,
            variables
          })
        }, cacheOptions));
        if (!fetchResponse.ok) {
          return null;
        }
        data = yield fetchResponse.json();
      }
      if (!revalidateCache && ((_data = data) === null || _data === void 0 || (_data = _data.errors) === null || _data === void 0 ? void 0 : _data.length) > 0) {
        fetchResponse = yield fetch(getEndpoint(), {
          method: 'POST',
          headers: headersObj,
          body: JSON.stringify({
            query,
            variables
          }),
          next: {
            revalidate: 1
          }
        });
        if (!fetchResponse.ok) {
          return null;
        }
        data = yield fetchResponse.json();
      }
      if (canLog && (_data2 = data) !== null && _data2 !== void 0 && _data2.errors && ((_data3 = data) === null || _data3 === void 0 || (_data3 = _data3.errors) === null || _data3 === void 0 ? void 0 : _data3.length) > 0) {
        logger.error(_objectSpread(_objectSpread({
          label: 'GRAPHQL_QUERY_ERROR'
        }, buildLogContext(operationName, variables, logContext)), {}, {
          errors: data.errors
        }));
      }
      if (!returnErrors && (!((_data4 = data) !== null && _data4 !== void 0 && _data4.data) || ((_data5 = data) === null || _data5 === void 0 || (_data5 = _data5.errors) === null || _data5 === void 0 ? void 0 : _data5.length) > 0)) {
        return null;
      }
      var selected = selector(data);
      success = selected !== null;
      return selected;
    } catch (error) {
      if (canLog) {
        logger.error(_objectSpread({
          label: 'GRAPHQL_QUERY_REQUEST_FAILED',
          err: error
        }, buildLogContext(operationName, variables, logContext)));
      }
      return null;
    } finally {
      if (logContext !== null && logContext !== void 0 && logContext.pageName && canLog) {
        var durationMs = Math.round(performance.now() - startTime);
        var variablesForLog = operationName === 'getAccountList' ? variables : undefined;
        logger.info({
          label: 'PAGE_GRAPHQL_REQUEST',
          pageName: logContext.pageName,
          operationName,
          userId: logContext.userId,
          companyId: logContext.companyId,
          variables: variablesForLog,
          durationMs,
          success
        });
      }
    }
  });
  return function executeGraphQLQuery(_x, _x2, _x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();
export var executeContentGraphQLQuery = (query, variables, selector, logContext) => executeGraphQLQuery(query, variables, selector, undefined, false, false, {}, logContext, true);
export var executeGraphQLMutation = function () {
  var _ref4 = _asyncToGenerator(function* (mutation, variables, selector, token) {
    var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    var logContext = arguments.length > 5 ? arguments[5] : undefined;
    var canLog = isServerSide();
    var operationName = deriveOperationName(mutation, logContext === null || logContext === void 0 ? void 0 : logContext.operationName);
    try {
      var _result$errors;
      var headersObj = yield getHeaders(token, headers);
      var res = yield fetch(getEndpoint(), {
        method: 'POST',
        headers: headersObj,
        body: JSON.stringify({
          query: mutation,
          variables
        }),
        cache: 'no-cache'
      });
      if (!res.ok) {
        return null;
      }
      var result = yield res.json();
      if (canLog && result !== null && result !== void 0 && result.errors && (result === null || result === void 0 || (_result$errors = result.errors) === null || _result$errors === void 0 ? void 0 : _result$errors.length) > 0) {
        logger.error(_objectSpread(_objectSpread({
          label: 'GRAPHQL_MUTATION_ERROR'
        }, buildLogContext(operationName, variables, logContext)), {}, {
          errors: result.errors
        }));
      }
      return selector(result);
    } catch (error) {
      if (canLog) {
        logger.error(_objectSpread({
          label: 'GRAPHQL_MUTATION_REQUEST_FAILED',
          err: error
        }, buildLogContext(operationName, variables, logContext)));
      }
      return null;
    }
  });
  return function executeGraphQLMutation(_x5, _x6, _x7, _x8) {
    return _ref4.apply(this, arguments);
  };
}();
var isServerSide = () => typeof window === 'undefined';
var getEndpoint = () => {
  var _process2, _process$env$NEXT_PUB2, _process4;
  if (isServerSide() && ((_process2 = process) === null || _process2 === void 0 || (_process2 = _process2.env) === null || _process2 === void 0 ? void 0 : _process2.NEXT_ENABLE_SERVER_APOLLO_GRAPHQL_ENDPOINT) === 'true') {
    var _process$env$NEXT_PUB, _process3;
    return (_process$env$NEXT_PUB = (_process3 = process) === null || _process3 === void 0 || (_process3 = _process3.env) === null || _process3 === void 0 ? void 0 : _process3.NEXT_PUBLIC_SERVER_APOLLO_GRAPHQL_ENDPOINT) !== null && _process$env$NEXT_PUB !== void 0 ? _process$env$NEXT_PUB : '';
  }
  return (_process$env$NEXT_PUB2 = (_process4 = process) === null || _process4 === void 0 || (_process4 = _process4.env) === null || _process4 === void 0 ? void 0 : _process4.NEXT_PUBLIC_GRAPHQL_ENDPOINT) !== null && _process$env$NEXT_PUB2 !== void 0 ? _process$env$NEXT_PUB2 : '';
};
export var getHeaders = function () {
  var _ref5 = _asyncToGenerator(function* (token) {
    var _process$env$NEXT_PUB3, _process5, _process$env$NEXT_PUB4, _process6;
    var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var contentRequest = arguments.length > 2 ? arguments[2] : undefined;
    var localhostHeaders = yield getLocalhostHeadersAsync(isServerSide());
    var sessionId = yield getSessionId();
    var isAppRouterEnv = yield isAppRouter();
    var forwardedHeaders = {};
    if (isServerSide() && isAppRouterEnv) {
      var nextHeadersFn = yield getNextHeaders();
      if (nextHeadersFn) {
        var _headersStore$get, _headersStore$get2;
        var headersStore = yield nextHeadersFn();
        forwardedHeaders = {
          'x-forwarded-for': (_headersStore$get = headersStore.get('x-forwarded-for')) !== null && _headersStore$get !== void 0 ? _headersStore$get : '',
          'True-Client-IP': (_headersStore$get2 = headersStore.get('True-Client-IP')) !== null && _headersStore$get2 !== void 0 ? _headersStore$get2 : ''
        };
      }
    }
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
      'Content-Type': 'application/json',
      'apollographql-client-name': (_process$env$NEXT_PUB3 = (_process5 = process) === null || _process5 === void 0 || (_process5 = _process5.env) === null || _process5 === void 0 ? void 0 : _process5.NEXT_PUBLIC_APP_NAME) !== null && _process$env$NEXT_PUB3 !== void 0 ? _process$env$NEXT_PUB3 : '',
      'apollographql-client-version': (_process$env$NEXT_PUB4 = (_process6 = process) === null || _process6 === void 0 || (_process6 = _process6.env) === null || _process6 === void 0 ? void 0 : _process6.NEXT_PUBLIC_APOLLO_CLIENT_VERSION) !== null && _process$env$NEXT_PUB4 !== void 0 ? _process$env$NEXT_PUB4 : ''
    }, localhostHeaders), forwardedHeaders), headers), token && !contentRequest && {
      Authorization: "Bearer ".concat(token)
    }), sessionId && !contentRequest && {
      [DEFAULT_TRACING_COOKIE_NAME]: sessionId
    });
  });
  return function getHeaders(_x9) {
    return _ref5.apply(this, arguments);
  };
}();
var isAppRouter = function () {
  var _ref6 = _asyncToGenerator(function* () {
    if (typeof window !== 'undefined') return false;
    var nextHeadersFn = yield getNextHeaders();
    if (!nextHeadersFn) return false;
    try {
      yield nextHeadersFn();
      return true;
    } catch (_unused3) {
      return false;
    }
  });
  return function isAppRouter() {
    return _ref6.apply(this, arguments);
  };
}();
var getSessionId = function () {
  var _ref7 = _asyncToGenerator(function* () {
    var isAppRouterEnv = yield isAppRouter();
    if (isServerSide() && isAppRouterEnv) {
      var nextCookiesFn = yield getNextCookies();
      if (nextCookiesFn) {
        var _cookieStore$get;
        var cookieStore = yield nextCookiesFn();
        return (_cookieStore$get = cookieStore.get(DEFAULT_TRACING_COOKIE_NAME)) === null || _cookieStore$get === void 0 ? void 0 : _cookieStore$get.value;
      }
      return undefined;
    } else if (!isServerSide()) {
      var _getCookie;
      return (_getCookie = getCookie('WB-SESSION-ID')) === null || _getCookie === void 0 ? void 0 : _getCookie.value;
    } else {
      return undefined;
    }
  });
  return function getSessionId() {
    return _ref7.apply(this, arguments);
  };
}();